<template>
  <div id="container" ref="mapRef" class="mainBox">
    <!-- 使用 vue-baidu-map-3x 提供的 BaiduMap 组件 -->

   <Nav curNavId="5" pathUrl='zhinengGG' @circle="clickNav" />
    <div class="content">
      <div class="left">
        <div class="leftBox1">
          <div class="title">气候数据监测</div>
          <div class="echartsBox"><leftBar1 :leftData1="state.leftData1" /></div>
        </div>
        <div class="leftBox2">
          <div class="title">土壤数据监测</div>
          <div class="echartsBox" >
            <div  v-if="state.leftData2.length==0" class="kong"><img src="../assets/img/gbzntyj/qixiang/jiazi.gif" style="width:50px" />加载中</div>
              <leftLine :leftData2="state.leftData2" v-else />
          </div>
        </div>
        <div class="leftBox3">
          <div class="title">降水预测指数</div>
          <!-- <div class="echartsBox"><leftBar2 :leftData3="state.leftData3" /></div> -->
          <div class="echartsBox" >
            <div  v-if="state.leftData3.length==0" class="kong"><img src="../assets/img/gbzntyj/qixiang/jiazi.gif" style="width:50px" />加载中</div>
              <leftBar2 :leftData3="state.leftData3" v-else />
          </div>
        </div>
      </div>
      <div class="center">
        <div class="centerBox1">
          <img src="../assets/img/gbzntyj/qixiang/zx.png" />
          <!-- <div class="video1" @click="videoClick(0)"></div>
          <div class="video2" @click="videoClick(1)"></div> -->
        </div>
        <div class="centerBox2" >
          <div class="title">未来7天气候预警</div>
          <div v-if="state.weatherArr.length ==0" class="kong"><img src="../assets/img/gbzntyj/qixiang/jiazi.gif" style="width:50px" />加载中</div>
          <div class="centerBox2_txt" v-else>

            <!-- <centerLine :leftData2="state.weatherArr" /> -->
            <centerLine :leftData2="state.centerWdData" />
          </div>


        </div>
      </div>
      <div class="right">
        <div class="rightBox1">
          <div class="title">灾害预警</div>
          <!-- <div v-if="state.rightData1[0].value[0].value ==0" class="kong"><img src="../assets/img/gbzntyj/qixiang/jiazi.gif" style="width:50px" />加载中</div> -->
          <div v-if="state.rightData1.length ==0" class="kong"><img src="../assets/img/gbzntyj/qixiang/jiazi.gif" style="width:50px" />加载中</div>
          <div class="rightContent1" v-else>
            <div class="rightContent1_con">
              <div class="rightContent1_con_item" v-for="(item,index) in state.rightData1" :key="index">
                <div class="time">{{item.date}}</div>
                <div class="value">{{item.day_wind_direction}}</div>
                <div class="value">{{item.day_wind_power}}</div>
                
              </div>
            </div>
          </div>
        </div>
        <div class="rightBox2">
          <div class="title">实时数据监测</div>
          <div v-if="state.rightData2[1].value =='' " class="kong"><img src="../assets/img/gbzntyj/qixiang/jiazi.gif" style="width:50px" />加载中</div>
          <div class="rightContent1" v-else>
            <div class="rightContent1_item" v-for="(item,index) in state.rightData2" :key="index">
              <img :src="item.icon" />
              <div class="rightContent1_item_r">
                <span class="name">{{item.name}}</span>
                <span class="value">{{item.value}}<i>{{item.unit}}</i></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <img src="../assets/img/gbzntyj/qixiang/dbbg.png" class="bottom" />
  </div>
<!--   <div class="footer">本产品由来村网提供技术支持</div>-->
  <CircleNav :isShow="state.circleShow"  @closeCircle1="circleHiddlen"  />
  <popBg :title="state.videoArr[state.videoIndex].name" :popShow="state.popShow" @hiddlen="popHiddlen">
    <!-- <vue3VideoPlay id="video"  width="100%"  height="100%"  title="冰河世纪"  :src="videoList[curVideoIndex].options.src"  :type="videoList[curVideoIndex].options.type"  :autoPlay="true"/> -->
    <div class="popInfo">
      <div class="videoBox">
        <div style="width: 100%; height: 100%" v-if="state.AccessToken != ''">
          <iframe :src="state.videoArr[state.videoIndex].options.src + state.AccessToken" width="100%"  height="100%" id="ysOpenDevice" allowfullscreen></iframe>
        </div>
      </div>
    </div>

  </popBg>
</template>

<script setup>
// @ is an alias to /src
import axios from "axios";
import { useRouter } from "vue-router";

import {
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
  onBeforeUnmount,
} from "vue";

import leftBar1 from '../components/QihouYj/leftBar1'
import leftBar2 from '../components/QihouYj/leftBar2'
import leftLine from '../components/QihouYj/leftLine'
import centerLine from '../components/QihouYj/centerLine1.vue'
import Nav from "../components/nav.vue";
import CircleNav from "@/components/circleNav.vue";
import popBg from "@/components/popBg.vue";
const router = useRouter();
const state = reactive({
  leftData1:[
    ['土壤检测', '空气检测', '光照检测', '风速检测'],
    [30, 30, 50, 10]
  ],
  leftData3:[],
  leftData2:[],
  rightData1:[],
  rightData2:[
    {name:"风速",unit:"m/s",icon:require('@/assets/img/gbzntyj/qixiang/fs.png')},
    {name:"光照",value:'',unit:"Lux",icon:require('@/assets/img/gbzntyj/qixiang/fx.png')},
    {name:"雨量",value:'',unit:"mm",icon:require('@/assets/img/gbzntyj/qixiang/dqy.png')},
    {name:"温度",value:'',unit:"℃",icon:require('@/assets/img/gbzntyj/qixiang/wdsd.png')},
    {name:"湿度",value:'',unit:"%",icon:require('@/assets/img/gbzntyj/qixiang/wdsd.png')},
    // {name:"光照",value:'1258',unit:"Lux",icon:require('@/assets/img/gbzntyj/qixiang/fx.png')},
  ],
  circleShow:false,
  weatherArr:[],
  popShow:false,
  videoArr:[
    {
      name:"监控设备",
      options: {
        src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/FB2502097/1.live&autoplay=1&accessToken=", //视频源
        type: "m3u8", //视频类型
      },
    },
    {
      name:"监控设备",
      options: {
        src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/FB2502097/2.live&autoplay=1&accessToken=", //视频源
        type: "m3u8", //视频类型
      },
    }
  ],
  videoIndex:0,
  AccessToken:"",
  centerWdData:[]
});

// 在 onMounted 中初始化地图
onMounted(() => {
  getData()
  state.AccessToken = localStorage.getItem('AccessToken')
});
function videoClick(index1) {
  state.videoIndex = index1;
  state.popShow = true;

}
function popHiddlen() {
  state.popShow = false;
}
function clickNav(isShow){
  // console.log(isShow)
  state.circleShow = isShow.show
}
function circleHiddlen(data1){
  // console.log('circle')
  state.circleShow = data1.show
}
function getData(){
    axios
      .get("https://zhfarm.laicunwang.com/api/environment/shangcaiqxCachedata", {sign:"c4c6cff9b7ec6b87fa953f77ec7e624b"})
      .then((res) => {
          console.log(res);
        // 土壤数据改为使用data2里的HistorydataResult
        state.leftData2[0] = res.data.data.data2.hoursResulttime.timeInfo;
        state.leftData2[1] = res.data.data.data2.HistorydataResult.soil_temperature;
        state.leftData2[2] = res.data.data.data2.HistorydataResult.soil_moisture;
 
          // console.log(state.leftData2)
          // state.leftData3[0] =  res.data.data.data1.time.timeInfo 
          // state.leftData3[1] =  res.data.data.data1.time.timeInfo 
           state.rightData2[0].value = res.data.data.data1.lastDatas[0].wind_cone
           state.rightData2[1].value = res.data.data.data1.lastDatas[0].light_intensity
           state.rightData2[2].value = res.data.data.data1.lastDatas[0].rainfall
           state.rightData2[3].value = res.data.data.data1.lastDatas[0].air_temperature
           state.rightData2[4].value = res.data.data.data1.lastDatas[0].air_humidity
           
          // 降水预测改为使用data5里的dates和precipitations
          let time = res.data.data.data5.dates
          let data = res.data.data.data5.precipitations
          state.leftData3=[time,data]
          // 天气：未来10小时气候预警改为使用data5里的dates和temps
          let centerWdData = []
          centerWdData.push(res.data.data.data5.dates)
          centerWdData.push(res.data.data.data5.temps)
          state.centerWdData = centerWdData
          // this.centerWdData[1] = res.data.data.data6.temperature

          // 未来10小时气候预警相关数据：包含temps、weathers、dates
          let weatherArr = []
          let dates = res.data.data.data5.dates
          let temps = res.data.data.data5.temps
          let weathers = res.data.data.data5.weathers

          for(var i = 0; i < dates.length; i++){
            let item = {
                time: dates[i],
                weather: weathers[i],
                value: temps[i]
            }
            weatherArr.push(item)
          }
          console.log(weatherArr)
        state.weatherArr = weatherArr

          let data1 = [
            {
                time: '2023-11-12 09:00',
                quality: '优',
                grade: '1级',
                weather: '大雪',
                value: 8
            },
            ]

        // 10天的气候
        // let weatherArr1 = []
        // let time1 = []
        // let weather1 = res.data.data.data5.daily.skycon
        // weather1.forEach(item=>{
        //   item.datetime = timeStr(item.datetime,2)
        //   time.push( item.date)
        //   // data.push(item.max)
        // })

        // for(var i = 0; i < weather1.length; i++){
        //   const datePart = weather1[i].date.split('T')[0];
        //   let time1 = {
        //     time:datePart,
        //     value: qingxiang(weather1[i].value)
        //   }
        //   // console.log(item)
        //   weatherArr1.push(time1)

        // }
        // console.log(weatherArr1)
        // state.rightData1[0].value = weatherArr1
        // 在获取新数据前先清空数组，避免数据累积
        state.rightData1 = []
        // 灾害预警改为风力、风向，使用data7
        state.rightData1= res.data.data.data7
        console.log(state.rightData1)


      });

}
function qingxiang(data){
  let name
  if(data=="CLEAR_DAY"){name="晴"}
  if(data=="CLEAR_NIGHT"){name="晴"}
  if(data=="PARTLY_CLOUDY_DAY"){name="多云"}
  if(data=="PARTLY_CLOUDY_NIGHT"){name="多云"}
  if(data=="CLOUDY"){name="阴"}
  if(data=="LIGHT_HAZE"){name="轻度雾霾"}
  if(data=="MODERATE_HAZE"){name="中度雾霾"}
  if(data=="HEAVY_HAZE"){name="重度雾霾"}
  if(data=="LIGHT_RAIN"){name="小雨"}
  if(data=="MODERATE_RAIN"){name="中雨"}
  if(data=="HEAVY_RAIN"){name="大雨"}
  if(data=="STORM_RAIN"){name="暴雨"}
  if(data=="FOG"){name="雾"}
  if(data=="LIGHT_SNOW"){name="小雪"}
  if(data=="MODERATE_SNOW"){name="中雪"}
  if(data=="HEAVY_SNOW"){name="大雪"}
  if(data=="STORM_SNOW"){name="暴雪"}
  if(data=="DUST"){name="浮尘"}
  if(data=="SAND"){name="沙尘"}
  if(data=="WIND"){name="大风"}
  return name
}

// 空气质量转换
function quality(qualityItem){
  // pm 25 优 25-50 良好  50-75  轻度污染 75-100 中度 100-150  中度 >150 严重
  let quality
  if(qualityItem <= 25){quality = '优'}
  if(qualityItem >= 25 && qualityItem <= 50){quality = '良好'}
  if(qualityItem > 50 && qualityItem <= 75){quality = '轻度' }
  if(qualityItem > 75 && qualityItem <= 100){quality =  '中度'}
  if(qualityItem > 100 && qualityItem <= 150){quality = '重度'}
  if(qualityItem > 150){quality = '严重'}
  return quality
}
// 风速转换
function fsTransform(speedItem){
  console.log(speedItem)
  let speed
  if(speedItem >= 0 && speedItem <= 0.2){speed = 0}
  if(speedItem >= 0.3 && speedItem <= 1.5){speed = 1}
  if(speedItem >= 1.6 && speedItem <= 3.4){speed = 2}
  if(speedItem >= 3.4 && speedItem <= 5.4){speed = 3}
  if(speedItem >= 5.5 && speedItem <= 7.9){speed = 4}
  if(speedItem >= 8.0 && speedItem <= 10.7){speed = 5}
  if(speedItem >= 10.7 && speedItem <= 13.8){speed = 6}
  if(speedItem >= 10.8 && speedItem <= 13.8){speed = 6}
  if(speedItem >= 13.9 && speedItem <= 17.1){speed = 7}
  if(speedItem >= 17.2 && speedItem <= 20.7){speed = 8}
  if(speedItem >= 20.8 && speedItem <= 24.4){speed = 9}
  if(speedItem >= 24.5 && speedItem <= 28.4){speed = 10}
  if(speedItem >= 28.5 && speedItem <= 32.6){speed = 11}
  if(speedItem >= 32.7 && speedItem <= 36.9){speed = 12}
  if(speedItem >= 37.0 && speedItem <= 41.4){speed = 13}
  if(speedItem >= 41.5 && speedItem <= 46.1){speed = 14}
  if(speedItem >= 46.2 && speedItem <= 50.9){speed = 15}
  if(speedItem >= 51.0 && speedItem <= 56.0){speed = 16}
  if(speedItem >= 56.1 && speedItem <= 61.2){speed = 17}
  console.log(speed)
  return speed
}

// 返回上一页
function clickReturn() {
  router.go(-1);
}
function timeStr(timeStr,type){
  // 将时间字符串转换为Date对象
  var date = new Date(timeStr)
  // 提取年、月、日
  var year = date.getFullYear()
  var month = ('0' + (date.getMonth() + 1)).slice(-2)
  var day = ('0' + date.getDate()).slice(-2)
  const hours = date.getHours()
  // const minutes = date.getMinutes()
  // 拼接年月日字符串
  if(type == 1){
    var ymdStr =  month + '-' + day
  }
  if(type == 2){
    // time: '2023-11-12 18:00',
    var ymdStr =  year +  '-' + month + '-' + day +' '+ hours + ':00'
  }
  
  // 返回年月日字符串
  return ymdStr
}
onUnmounted(() => {});
onBeforeUnmount(() => {
  // clearInterval(timer.value);
});


</script>
<style lang="less" scoped>
.kong{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 20px;
  img{
    margin-bottom: 20px;
  }
}
.popInfo{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  .videoBox{
    width: 100%;
    height:100%;
  }
  .openBtn{
    position: absolute;
    left: 50%;
    bottom: 0px;
    background: url("../assets/img/gbzntyj/gaungai/kg.png") no-repeat;
    width: 193px;
    height: 102px;
    z-index: 1000;
    margin-left: -97px;
    color: #fff;
    line-height: 102px;
    font-size: 18px;
  }
}
.footer{
    width: 100%;
    height: 30px;
    line-height: 30px;
    color: #fff;
    text-align: center;
    font-size: 14px;
    position: fixed;
    bottom: 30px;
    left: 0;
    z-index: 10000;
    font-weight: bold;
    }
body {
  background-size: cover;
  line-height: 1.15;
}
::v-deep .el-tabs__item {
  width: 102px;
  height: 72px;
  padding: 0;
  // border: 1px solid #1a6266;
  display: flex;
  justify-content: center;

  align-items: self-start;
  position: relative;
  margin: 0 10px;
  flex-shrink: 0;
  box-sizing: border-box;
  color: #fff;
  background: url("../assets/img/plantmoxing/xz.png") no-repeat top center;
  background-size: 100% 100%;
}
::v-deep .el-tabs__item::before,
::v-deep .el-tabs__item::after {
  content: " ";
  background: #21fcff;
  width: 2px;
  height: 12px;
  position: absolute;
  top: 12px;
  background: url("../assets/img/plantmoxing/xz.png") no-repeat top center;
  background-size: 100% 100%;
}
::v-deep .el-tabs__item::before {
  left: -1px;
}
::v-deep .el-tabs__item::after {
  right: -1px;
}
::v-deep .el-tabs__nav {
  display: flex;
}
::v-deep .el-tabs__nav-wrap::after {
  display: none;
}
::v-deep .el-tabs__active-bar {
  width: 100%;
  background-color: #21fcff;
}
::v-deep .is-active {
  color: #a1c81f;
}
::v-deep .el-tabs__nav-prev {
  position: absolute;
  cursor: pointer;
  background: url("../assets/img/plantmoxing/zjt.png") no-repeat top center;
  background-size: 100% 100%;
  width: 18px;
  height: 23px;
  left: 1px;
  top: 20px;

  color: transparent; /* 文字颜色透明 */
}

.mainBox {
  width: 100%;
  height: 100vh;
  position: absolute;
  position: absolute;
  background: url("../assets/img/gbzntyj/qixiang/bj.jpg") no-repeat top center;
  background-size: 100% 100%;
  .dh_wz {
    width: 170px;
    height: 47px;
    position: absolute;
    left: 3%;
    top: 20%;
    background: url("../assets/img/gbzntyj/yy.png") no-repeat top center;
    background-size: 100% 100%;

    .dh_wz_qq {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      position: absolute;
      top: 6px;
      left: 7px;
      border: 1px solid #ffc600; /* 添加一个黑色的边框 */
    animation: guangying 2s linear infinite;
    }
    .dh_wz_tb {
        width: 20px;
        height: 20px;
        position: absolute;
        left: 15px;
        top: 14px;
        background: url("../assets/img/gbzntyj/nt.png") no-repeat top center;
        background-size: 100% 100%;
        animation: topIcon 2s linear infinite;
      }
    .dh_wz_wz {
      width: 120px;
      height: 47px;
      line-height: 47px;
      color: #fff;
      font-size: 20px;
      font-weight: 500;
      text-align: center;
      position: absolute;
      right: 5%
    }
  }
  .topContent {
    width: 100%;
    height: 90px;
    position: relative;
    .titleRightImg {
      position: absolute;
      right: 0;
      top: 26%;
      .return {
        width: 77px;
        height: 32px;
        margin-right: 15px;
        cursor: pointer;
        position: relative;
        z-index: 999;
      }
    }
  }

  .dh_lb {
    // width: 900px;
    height: 45px;
    position: absolute;
    left: 23%;
    top: 20%;
    display: flex;
    flex-flow: row;
    a {
      text-decoration: none;
    }

    .dh_lb_bt {
      width: 124px;
      height: 43px;
      background: url("../assets/img/gbzntyj/yy.png") no-repeat top center;
      background-size: 100% 100%;
      flex: 1;
      margin: 0 5px;
      font-family: MicrosoftYaHei;
      font-size: 16px;
      line-height: 43px;
      text-align: center;
      color: #3bf4be;
      transition: all 0.5s ease-out;
    }
    .dh_lb_bt:hover,
    .dh_lb_bt_cur {
      width: 124px;
      height: 43px;
      cursor: pointer;
      background: url("../assets/img/gbzntyj/xz.png") no-repeat top center;
      background-size: 100% 100%;
      flex: 1;
      margin: 0 5px;
      font-family: MicrosoftYaHei;
      font-size: 16px;
      line-height: 43px;
      text-align: center;
      color: #fff;
    }
  }

  .content{
    width: 100%;
    height: calc(100% - 91px);
    display: flex;
    padding: 0 30px;
    box-sizing: border-box;
    .left{
      width: 476px;
      height: 100%;
      display: flex;
      flex-direction: column;
      .leftBox1{
        width: 100%;
        height: 33%;
        display: flex;
        flex-direction: column;
      }
      .leftBox2{
        width: 100%;
        height: 30%;
        margin-top: 10px;
        display: flex;
        flex-direction: column;
      }
      .leftBox3{
        width: 100%;
        height:34%;
        margin-top: 10px;
        display: flex;
        flex-direction: column;
      }
    }
    .right{
      width: 476px;
      height: 100%;
      display: flex;
      flex-direction: column;
      .rightBox1{
        width: 100%;
        height: 33%;
        display: flex;
        flex-direction: column;
        .rightContent1{
          width: 1005;
          flex: 1;
          padding: 10px 20px;
          display: flex;
          flex-direction: column;
          .rightContent1_tit{
            width: 100%;
            height: 28px;
            display: flex;
            justify-content: space-between;
            .rightContent1_tit_item{
              width: 71px;
              height: 28px;
              background: url("../assets/img/gbzntyj/qixiang/wxz.png") no-repeat;
              text-align: center;
              line-height: 34px;
              color: #fff;
              font-size: 14px;
              cursor: pointer;
              // margin: 0 20px;
            }
            .rightContent1_tit_itemCur{
              color: #00F5E1;
              background: url("../assets/img/gbzntyj/qixiang/xz.png") no-repeat;
            }
          }
          .rightContent1_con{
            width: 100%;
            flex: 1;
            display: flex;
            align-content: space-between;
            flex-wrap: wrap;
            padding: 16px 30px;
            .rightContent1_con_item{
              width: 103px;
              font-size: 14px;
              margin: 0 5px;
              .value{
                width: 100%;
                height: 27px;
                background: url('../assets/img/gbzntyj/qixiang/ls.png') no-repeat;
               background-size: 100% 100%;
                text-align: center;
                line-height: 30px;
                color: #00F5E1;
                font-weight: bold;
              }
              .time{
                color: #fff;
                text-align: left;
                position: relative;
                padding-left: 15px;
                line-height: 26px;
              }
              .time::before{
                content: '';
                width: 6px;
                height: 6px;
                background:#00F5E1 ;
                position: absolute;
                left: 0;
                top: 10px;
              }
              
            }
            .rightContent1_con_itemCur{
              .value{
                background: url('../assets/img/gbzntyj/qixiang/hs.png') no-repeat;
                color: #F0C85C;
              }
              .time::before{
                background:#F0C85C ;
              }
              
            }
          }
        }
      }
      .rightBox2{
        width: 100%;
        flex: 1;
        display: flex;
        flex-direction: column;
        .rightContent1{
          width: 100%;
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 30px 0 50px;
          .rightContent1_item{
            width: 331px;
            height: 90px;
            padding: 0 36px;
            margin: 0 auto;
            display: flex;
            align-items: center;
            justify-content: space-between;
            background: url("../assets/img/gbzntyj/qixiang/jx.png") no-repeat;
            img{
              width: 35px;
              height: 33px;
              margin-right: 60px;
            }
            .rightContent1_item_r{
              flex: 1;
              display: flex;
              justify-content: space-between;
              line-height: 90px;
              span{
                display: block;
              }
              .name{
                font-size: 18px;
                color: rgba(255,255,255,.8);
                margin-right: 30px;
              }
              .value{
                color: #10E6B7;
                font-size: 26px;
                font-weight: bold;
                i{
                  font-size: 16px;
                }
              }
            } 
          }
        }
      }
    }
    .center{
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .centerBox1{
        height: 50%;
        position: relative;
        img{
          //width: 100%;
          height: 100%;
        }
        .video1{
          position: absolute;
          top: 53%;
          left: 8%;
          //border: 1px solid #f00;
          width: 14%;
          height: 30%;
          cursor: pointer;
        }
        .video2{
          position: absolute;
          top: 53%;
          right: 5%;
          //border: 1px solid #f00;
          width: 14%;
          height: 30%;
          cursor: pointer;
        }
      }
      .centerBox2{
        width: 100%;
        //height: 50%;
        flex: 1;
        display: flex;
        flex-direction: column;
        .centerBox2_txt{
          width: 100%;
          flex: 1;
        }
        // border: 1px solid;
      }
    }
  }
  .bottom{
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 30px;
    left: 0;
    z-index: 0;
  }
  .title{
    width: 452px;
    height: 50px;
    line-height: 50px;
    background: url("../assets/img/gbzntyj/qixiang/xbt.png") no-repeat left bottom;
    text-align: left;
    color: #fff;
    font-size: 18px;
    padding-left: 30px;
  }
  .echartsBox{
    width: 100%;
    flex: 1;
  }
}
@keyframes guangying {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-360deg);
  }
}
@keyframes left1Img {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.3);
  }
  100% {
    transform: scale(1);
  }
}
.contentLine {
  background: #1aa19e;
  position: absolute;
}
.contentLine1 {
  top: 1px;
  left: 0;
  width: 10%;
  height: 2px;
  /* 加上渐变效果，方可形成拖尾效果 */
  background: linear-gradient(90deg, transparent, #1aa19e);
  animation: animate1 4s linear infinite;
}
.contentLine2 {
  top: -100%;
  right: 0;
  width: 2px;
  height: 20%;
  background: linear-gradient(180deg, transparent, #1aa19e);
  animation: animate2 4s linear infinite;
  /* 注意要加上延时触发动画效果，这样线条才会依次触发 */
  animation-delay: 1s;
}
.contentLine3 {
  bottom: 1px;
  right: 0;
  width: 20%;
  background: linear-gradient(270deg, transparent, #1aa19e);
  animation: animate3 4s linear infinite;
  animation-delay: 2s;
}
.contentLine4 {
  bottom: -100%;
  left: 1px;
  width: 2px;
  height: 10%;
  background: linear-gradient(360deg, transparent, #1aa19e);
  animation: animate4 4s linear infinite;
  animation-delay: 3s;
}
/* 定义关键帧 */
@keyframes guangying {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-360deg);
  }
}

@keyframes animate1 {
  0% {
    left: -50%;
  }

  50%,
  100% {
    left: 100%;
  }
}

@keyframes animate2 {
  0% {
    top: -100%;
  }

  50%,
  100% {
    top: 100%;
  }
}
@keyframes animate3 {
  0% {
    right: -100%;
    height: 3px;
  }

  50%,
  100% {
    height: 2px;
    right: 100%;
  }
}
@keyframes animate4 {
  0% {
    bottom: -100%;
  }

  50%,
  100% {
    bottom: 100%;
  }
}
@keyframes topIcon {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(15deg);
    transform: scale(.9);
  }
  75% {
    transform: rotate(-15deg);
    // transform: scale(.9);
  }
   100% {
    transform: rotate(0);
  }
}
</style>
